import http from '@/api/common'

export default {
  async getIssues(key) {
    const response = await http.get(`admin/issue/${key}/2`)
    return response
  },

  async getStatuses() {
    const response = await http.get('lookup/GetLookupValues?key=workorder.status')
    if (response.data && Array.isArray(response.data)) {
      response.data.sort((a, b) => a.text.localeCompare(b.text))
    }
    return response
  },

  // Upsert an issue
  upsertIssue(data) {
    return http.post('admin/issue/upsert', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/issues.js